var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "64px",
    viewBox: "0 0 59 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/04",
    transform: "translate(-3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0.986902668 L28.8353969,52.9902706 L4.72645473,30.5917749 L3.23692136,32.2145343 L31.7552333,58.7085657 C31.7618145,58.7129813 31.772783,58.7151892 31.7793642,58.7218127 C31.8122699,58.7527224 31.8517568,58.7748007 31.88905,58.7990869 C31.919762,58.8189575 31.9504741,58.8344123 31.9811861,58.852075 C32.0009295,58.8631142 32.0162856,58.8741534 32.0338353,58.8829847 C32.0623536,58.8962317 32.0864845,58.9183101 32.1150028,58.9293492 C32.2356572,58.9757138 32.3650864,59 32.4989031,59 C32.6349136,59 32.7643428,58.9757138 32.8849972,58.9293492 C32.9113218,58.9183101 32.9354527,58.8962317 32.963971,58.8851925 C32.9815207,58.8741534 32.9990705,58.8631142 33.0166202,58.852075 C33.0495259,58.8344123 33.0780442,58.8189575 33.1087563,58.7990869 C33.1460495,58.7748007 33.1855363,58.7527224 33.2206358,58.7218127 C33.227217,58.7151892 33.2359918,58.7129813 33.2447667,58.7085657 L61.7630786,32.2145343 L60.2735453,30.5917749 L36.1646031,52.9902706 L62,0.986902668 L60.0366239,0 L35.0589701,50.2768402 L42.3508831,11.7390637 L40.1966537,11.3261984 L32.4989031,51.9967444 L24.8011526,11.3261984 L22.6469232,11.7390637 L29.9410299,50.2768402 L4.96337609,0 L3,0.986902668 Z",
    id: "Fill-1",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,44 C37.5228475,44 42,48.4771525 42,54 C42,59.5228475 37.5228475,64 32,64 C26.4771525,64 22,59.5228475 22,54 C22,48.4771525 26.4771525,44 32,44 Z M32,50.6666667 C30.1590508,50.6666667 28.6666667,52.1590508 28.6666667,54 C28.6666667,55.8409492 30.1590508,57.3333333 32,57.3333333 C33.8409492,57.3333333 35.3333333,55.8409492 35.3333333,54 C35.3333333,52.1590508 33.8409492,50.6666667 32,50.6666667 Z",
    id: "Combined-Shape",
    fill: "#FFE8AC",
    className: "fill-dynamic-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon04.32a72b4107f418157fc9dc352c41195e.svg";
export { ForwardRef as ReactComponent };